<template>
<div class="product">
  <el-container>
    <el-header id="top">
        <div class="container nav"
         v-bind:class="{ 'navActive': scrollFlag }">
          
          <el-menu
            :default-active="activeproduct"
            class="el-menu-demo"
            mode="horizontal"
           
            @select="handleSelect"
           
            >
            <div class="logo"><img src="../assets/logo.png" ></div>
            <el-menu-item index="6" class="hr" @click="toRecruit">诚聘英才</el-menu-item>
            <el-menu-item index="5" @click="toBg6">联系我们</el-menu-item>
            <el-menu-item index="4" @click="toBg5">软件著作权</el-menu-item>
            <el-menu-item index="3" @click="toBg4">合作伙伴</el-menu-item>
            <el-menu-item index="2" @click="toBg3">业务介绍</el-menu-item>
            <el-menu-item index="1" @click="goIndex">首页</el-menu-item>
            
          </el-menu>
        </div>
        <div class="container nav2"
        v-bind:class="{ 'navActive2': scrollFlag }">
          <el-menu :default-active="activeProduct2" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" @click="toTop">内容转接平台<span class="menuline"></span></el-menu-item>
            <el-menu-item index="2" @click="toP2">云金融服务平台<span class="menuline"></span></el-menu-item>
            <el-menu-item index="3" @click="toP3">信用卡还款系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="4" @click="toP4">互联网支付系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="5" @click="toP5">慧收付系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="6" @click="toP6">便民缴费系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="7" @click="toP7">银行发卡系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="8" @click="toP8">信贷管理系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="9" @click="toP9">银行卡收单系统<span class="menuline"></span></el-menu-item>
            <el-menu-item index="10" @click="toP10">聚合支付系统</el-menu-item>

          </el-menu>
        </div>
        <div class="scrollbg" v-if="scrollFlag"></div>
        
    </el-header>
    <div class="bg1" id="top">
      <div class="container">
        <img src="../assets/product1.png">
      </div>
    </div>
    <div class="bg2" id="p2">
      <div class="container">
        <img src="../assets/product2.png">
      </div>
    </div>
    <div class="bg3" id="p3">
      <div class="container">
        <img src="../assets/product3.png">
      </div>
    </div>
    <div class="bg4" id="p4">
      <div class="container">
        <img src="../assets/product4.png">
      </div>
    </div>
    <div class="bg5" id="p5">
      <div class="container">
        <img src="../assets/product5.png">
      </div>
    </div>
    <div class="bg6" id="p6">
      <div class="container">
        <img src="../assets/product6.png">
      </div>
    </div>
    <div class="bg7" id="p7">
      <div class="container">
        <img src="../assets/product7.png">
      </div>
    </div>
    <div class="bg8" id="p8">
      <div class="container">
        <img src="../assets/product8.png">
      </div>
    </div>
    <div class="bg9" id="p9">
      <div class="container">
        <img src="../assets/product9.png">
      </div>
    </div>
    <div class="bg10" id="p10">
      <div class="container">
        <img src="../assets/product10.png">
      </div>
    </div>
    
    
    <el-footer class="footer">
        <div class="container">
            <div class="nav">
              <div class="navcon" @click="goIndex">首页</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg3">业务介绍</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg4">合作伙伴</div>
              <div class="navline"></div>
              <div class="navcon long" @click="toBg5">软件著作权</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg6">联系我们</div>
              <div class="navline"></div>
              <div class="navcon" @click="toRecruit">诚聘英才</div>
              
            </div>
            <div class="copyright">
              <div class="left">
                <div class="title1">上海镒道网络科技有限公司(c)</div>
                <div class="title2" @click="gobeian">2024 All Rights Reserved 沪ICP备2024076183号-1</div>
                <div class="title2" @click="gonganGobeian">沪公网安备31011502401276</div>
              </div>
              <div class="right">
                <div class="logo"><img src="../assets/logo.png" ></div>
              </div>
              
            </div>
          </div>  
      </el-footer>
  </el-container>
</div>
</template>

<script>

export default {
  name: 'HelloWorld',
  data () {
    return {
      activeproduct: '',
      activeProduct2:'1',
      scrollFlag:false,
      

    }
  },
  methods: {
    toRecruit(){
        this.$router.push('/recruit')
      },
    gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      gonganGobeian(){
        window.location.href = 'https://beian.mps.gov.cn/#/query/webSearch?code=31011502401276';
      },
      goIndex(){
        sessionStorage.setItem('nav','index')
        this.$router.push('/')
      },
      goproduct(){
        this.$router.push('/product')
      },
      toTop(e){
        document.getElementById("top").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP2(){
        document.getElementById("p2").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP3(){
        document.getElementById("p3").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP4(){
        document.getElementById("p4").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP5(){
        document.getElementById("p5").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP6(){
        document.getElementById("p6").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP7(){
        document.getElementById("p7").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP8(){
        document.getElementById("p8").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP9(){
        document.getElementById("p9").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toP10(){
        document.getElementById("p10").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toBg3(){
         sessionStorage.setItem('nav','Bg3')
         this.$router.push('/')
      },
      toBg4(){
        sessionStorage.setItem('nav','Bg4')
         this.$router.push('/')
      },
      toBg5(){
        sessionStorage.setItem('nav','Bg5')
         this.$router.push('/')
      },
      toBg6(){
        sessionStorage.setItem('nav','Bg6')
         this.$router.push('/')
      },
      handleSelect(key, keyPath) {
        
      },
      handleScroll () {
        let _this=this;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop)
        if(scrollTop){
          _this.scrollFlag=true
        }else{
          _this.scrollFlag=false
        }
      },
      
      
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)
    this.toTop()
  }
} 

</script>
<style scoped>
.product .bg1 img{
  width: 1080px;
  height: 1440px;
}
.product .bg2{
  background: #F7F7F7;
}
.product .bg2 img{
  width: 1080px;
  height: 880px;
}
.product .bg3 img{
   width: 1080px;
  height: 830px;
}
.product .bg4{
  background: #F7F7F7;
}
.product .bg4 img{
   width: 1080px;
  height: 920px;
}
.product .bg5 img{
   width: 1080px;
  height: 600px;
}
.product .bg6{
  background: #F7F7F7;
}
.product .bg6 img{
   width: 1080px;
  height: 1000px;
}
.product .bg7 img{
   width: 1080px;
  height: 1180px;
}
.product .bg8{
  background: #F7F7F7;
}
.product .bg8 img{
   width: 1080px;
  height: 1310px;
}
.product .bg9 img{
   width: 1080px;
  height: 880px;
}
.product .bg10{
  background: #F7F7F7;
}
.product .bg10 img{
   width: 1080px;
  height: 960px;
}
.product .footer{
  width: 100%;
 
  height: 330px!important;
  background-image: url("../assets/bg_06.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;

}
.product .footer .copyright{
  margin-top: 30px;
  overflow: hidden;

}
.product .footer .copyright .left{
  float: left;
  text-align: left;
}
.product .footer .copyright .left .title1{
  font-family: PingFangSC-Semibold;
font-size: 14px;
color: #FFFFFF;
font-weight: 600;
}
.product .footer .copyright .left .title2{
font-family: PingFangSC-Regular;
font-size: 14px;
color: #848991;
margin-top: 4px;
cursor: pointer;
}
.product .footer .copyright .right{
  float: right;
  margin-top: -6px;
}
.product .footer .nav{
  margin-top: 110px;
}
.product .footer .navcon{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
float: left;
width: 94px;
cursor: pointer;
}
.product .footer .navcon.long{
width: 109px;
}
.product .footer .navcon:hover{
  opacity: 0.5;
  color:#fff
}
.product .footer .navcon:first-child{
text-align: left;
width: 50px;
}

.product .footer .navline{
  width: 1px;
  height: 16px;
  display: block;
  float: left;
  background: #DBBA66;
  margin-top: 3.5px;
}
.product>>>.el-carousel{
  
}

.product>>>.el-carousel__button{
width: 40px;
height: 6px;
background: #F1F1F1;
opacity: 1;
cursor: pointer;
}
.product>>>.el-carousel__indicator.is-active button{
  background: #DBBA66;
}
.product>>>.el-carousel__mask{
  background-color: transparent;
  opacity: 0;
}
 .carousel-img {
    max-width: 100%;
    max-height: 100%;
  }

  
  .el-carousel__item:nth-child(2n) {
   
  }
  
  .el-carousel__item:nth-child(2n+1) {
    
  }
.product{
 height: 100%;
}
.product .el-fade-in-linear-leave-active{
  transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.product .el-fade-in-linear-enter-active{
transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.product .scrollbg{
  height: 160px;
}
.product .el-main{
  padding: 0;
    margin-top: -140px;

}

.product .logo{
  display: block;
  float: left;
  width: 200px;
  height: 60px;
  
 
}
.product .nav{
  width: 100%!important;
  height: 80px;
  background: #0B1525;
  overflow: hidden;
}
.product .nav2{
  overflow: hidden;
  width: 100%!important;
  height: 80px;
  background: #F7F7F7;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
}

.product .logo img{
  width: 200px;
  height: 60px;
}
.product .el-header{
  height: 160px!important;
  width: 100%;
 
  padding: 0;
  
  position: relative;
}

.product .container{
  width: 1080px;
  margin: 0 auto;
  position: relative;
}







.product .el-menu.el-menu--horizontal{
  border-bottom:none;
  background:transparent;
  width: 1080px;
  margin: 10px auto;
}
.product .el-menu--horizontal>.el-menu-item{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
padding: 0 15px;
float: right;
}
.product .hr{
  border: 1px solid #FFFFFF!important;
border-radius: 4px;
border-radius: 4px;
width: 100px;
height: 40px;
line-height: 40px;
margin-top: 9px;
margin-left: 12px;


}
.product .el-menu--horizontal>.el-menu-item:hover{
  background-color: transparent;
  opacity: 0.5;
  color:#fff
}
.product .el-menu--horizontal>.el-menu-item.is-active{
  color: #fff;
  background-color: transparent;
  border-bottom: 1px solid #DBBA66;
}
.product .navActive{
position: fixed;
top: 0;
z-index: 100;
height: 80px;

}
.product .navActive2{
position: fixed;
top: 80px;
z-index: 100;
height: 80px;

}
.product .nav2 .el-menu--horizontal>.el-menu-item{
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
float: left;
padding: 0;
text-align: center;
margin-right: 11px;
}
.product .nav2 .el-menu--horizontal>.el-menu-item:first-child{
  padding-left: 0;
}
.product .nav2 .el-menu--horizontal>.el-menu-item:last-child{
  margin-right: 0;
}
.product .nav2 .el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: transparent;
  text-decoration: underline;
  font-weight: 600;

}
.product .nav2 .el-menu--horizontal>.el-menu-item .menuline{
  background: #DDDDDD;
  width: 1px;
  height: 16px;
  display: inline-block;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/product.vue